import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ActivationCodeDetails } from '../../model/user/activation-code-details.model';
import { RegistrationInfo } from '../../model/user/registration-info.model';
import { EnvironmentConfig } from '../../model/environment.model';
import { ENV_CONFIG } from '../../injection-tokens/environment.token';

@Injectable({
    providedIn: 'root',
})
export class UserRegistrationService {
    private readonly _httpClient: HttpClient = inject(HttpClient);
    private readonly _environment: EnvironmentConfig = inject(ENV_CONFIG);

    public registrationLookup(code: string): Observable<ActivationCodeDetails> {
        return this._httpClient.get<ActivationCodeDetails>(
            `${this._environment.APP.VC_USER_REGISTRATION_BASE_URL}/lookup?code=${code}`
        );
    }

    public register(user: RegistrationInfo): Observable<void> {
        return this._httpClient.post<void>(`${this._environment.APP.VC_USER_REGISTRATION_BASE_URL}/register`, user);
    }
}
